import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';
import { headerTypographyProps } from '../../../styles/sxStyling';
import { FormTemplateLink } from '../../../types/FormTemplate';
import { useGetAllContacts } from '../../../services/react-query/contacts';
import { Contact } from '../../../types/Contact';
import { useCreateFormSubmission } from '../../../services/react-query/form_submissions';

interface IInviteSendModalProps {
  isOpen: boolean;
  onCancel: () => void;
  accountUuid?: string;
  formTemplateLink: FormTemplateLink | null;
}

export default function InviteSendModal({ isOpen, onCancel, accountUuid, formTemplateLink }: IInviteSendModalProps) {
  const { data: contactsResponse } = useGetAllContacts({ params: { filters: { account: accountUuid }, per_page: 0 }, enabled: !!accountUuid });
  const { mutate: createFormSubmission } = useCreateFormSubmission({
    onSuccessCallback: () => onCancel(),
  });
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);

  if (!accountUuid || !formTemplateLink) return null;

  const handleInvite = () => {
    if (!selectedContact) return;

    createFormSubmission({
      event_form_template_uuid: formTemplateLink.uuid,
      email: selectedContact.email,
    });
  };

  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth>
      <DialogTitle>Form Invitation</DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
        <DialogContentText>
          Please choose which contact to send the invite to.
        </DialogContentText>

        <Autocomplete<Contact>
          options={contactsResponse?.data}
          value={selectedContact}
          getOptionLabel={(contact: Contact) => contact.full_name || ''}
          onChange={(_, value) => {
            setSelectedContact(value);
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" disabled={!selectedContact} onClick={handleInvite}>
          Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
}
